// 통계 페이지의 "운영 인사이트" 섹션 — 운영진 전용.
//
// 현재는 "최근 N회 일정에 한 번도 참여 안 한 활성 회원" 휴면 신호 하나만
// 노출. 완료된 일정이 3개 미만이거나 데이터가 없으면 안내 카피만.

import { mountPreact } from "../ui/preact-mount";

interface MemberLike {
  member_id: string;
  name?: string | null;
  member_status?: string;
  level_category?: string | null;
}

interface ParticipantSnapshot {
  member_id?: string | null;
  attendance_status?: string;
}

interface EventDetail {
  participants?: ParticipantSnapshot[];
}

function AdminInsights({
  details,
  members,
}: {
  details: EventDetail[];
  members: MemberLike[];
}) {
  let dormant: MemberLike[] = [];
  if (details.length >= 3 && members && members.length > 0) {
    const participated = new Set<string>();
    for (const d of details) {
      for (const p of (d.participants || [])) {
        const st = p.attendance_status;
        if ((st === "confirmed" || st === "checked_in") && p.member_id) {
          participated.add(p.member_id);
        }
      }
    }
    dormant = members.filter((m) =>
      (m.member_status || "active") === "active" && !participated.has(m.member_id),
    );
  }

  return (
    <div class="section section--panel">
      <div class="section__title">
        <h3>운영 인사이트</h3>
        <span class="badge badge--admin-only">운영진만 보여요</span>
      </div>
      {dormant.length > 0 ? (
        <>
          <p class="stat-block__label">
            최근 {details.length}회 일정에 한 번도 참여하지 않은 활성 회원 ({dormant.length}명)
          </p>
          <div class="player-stat-list">
            {dormant.map((m) => (
              <div key={m.member_id} class="player-stat-row">
                <span class="player-stat-row__name">{m.name || "이름 없음"}</span>
                <span class="player-stat-row__meta">{m.level_category || "-"}</span>
              </div>
            ))}
          </div>
        </>
      ) : (
        <p class="muted small">완료된 일정이 3개 이상 쌓이면 휴면 회원 등 인사이트가 표시돼요.</p>
      )}
    </div>
  );
}

export function buildAdminInsightsSection(
  details: EventDetail[],
  members: MemberLike[],
): HTMLElement {
  return mountPreact(<AdminInsights details={details} members={members} />);
}
